import React, { createContext, useCallback, useMemo, useState } from 'react';

import { DEFAULT_TOAST_DATA } from '../../constants/toast';
import { IStoriesContext, IStoryData } from '../../interfaces/stories';
import { IToast } from '../../interfaces/toast';

const contextDefaultValues: IStoriesContext = {
  storyDuplication: undefined,
  toastData: DEFAULT_TOAST_DATA,
  openToast: false,
  changeStoryDuplication: () => {
    return;
  },
  changeToastData: () => {
    return;
  },
  changeOpenToast: () => {
    return;
  }
};

export const StoriesContext = createContext<IStoriesContext>(contextDefaultValues);

const StoriesContextProvider = ({ children }: React.PropsWithChildren) => {
  const [storyDuplication, setStoryDuplication] = useState<IStoryData | undefined>(
    contextDefaultValues.storyDuplication
  );
  const [openToast, setOpenToast] = useState(contextDefaultValues.openToast);
  const [toastData, setToastData] = useState<IToast>(contextDefaultValues.toastData);

  const changeOpenToast = useCallback((isOpen: boolean) => {
    setOpenToast(isOpen);
  }, []);

  const changeToastData = useCallback((toastData: IToast) => {
    setToastData(toastData);
  }, []);

  const changeStoryDuplication = useCallback((storyDuplication: IStoryData | undefined) => {
    setStoryDuplication(storyDuplication);
  }, []);

  const value = useMemo(
    () => ({ storyDuplication, openToast, toastData, changeStoryDuplication, changeOpenToast, changeToastData }),
    [storyDuplication, openToast, toastData, changeStoryDuplication, changeOpenToast, changeToastData]
  );

  return <StoriesContext.Provider value={value}>{children}</StoriesContext.Provider>;
};

export default StoriesContextProvider;
